import { Option } from 'interfaces';

export const sortOptions = (options: Option[]) =>
   options.sort((firstOption, secondOption) =>
      firstOption.label.localeCompare(secondOption.label, 'pl-PL', { caseFirst: 'upper' }),
   );
